import { useRequestsBankOpsEditable } from 'pages/Finance/RequestsBankOps/hooks/useRequestsBankOpsEditable';
import { useRecordContext } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { useGetFiles } from 'shared/widgets/TableFileViewer/hooks/useGetFiles';
import { TableFileViewer } from 'shared/widgets/TableFileViewer/TableFileViewer';
import { BankOperation } from 'types/embedded/bankOperation';

export const RequestsBankOpsShowTabsFiles: React.FC = () => {
  const record = useRecordContext<BankOperation>();
  const { isFileEdit } = useRequestsBankOpsEditable();

  const { data: files } = useGetFiles('bank_operation', record?.originId);

  return record && (isFileEdit(record) || (files && files.length > 0)) ? (
    <TableFileViewer
      allowUpdate={isFileEdit(record)}
      entityId={record.originId}
      entityName="bank_operation"
    />
  ) : (
    <Alert severity="info">Нет файлов.</Alert>
  );
};
